import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import Moment from 'react-moment';
import moment from 'moment';
import Help from '../../../generics/help';
import { donationTypeExtraction } from '../../../../libs/services';
import { Table,Button } from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {filePdf} from 'react-icons-kit/icomoon/filePdf';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class IncidentReport extends Component{
    constructor(props){
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.searching = this.searching.bind(this);

        this.state = {
            month:"",
            end_date:"",
            listado:[],
            year:"",
            periodo:"",
            data:[],
            header:[]
        }
    }
    componentWillMount(){}
    componentDidMount(){
        fetch(Config.default.apiGateway.URL+'look_and_feel',{
            method:'GET',
            headers:new Headers({
                'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8'
              })
        }).then(res => {
            if(res.ok){
              return res.json();
            }console.log(res)})
          .catch(error => console.error('Error:', error))
          .then(response => {
              console.log(response);
              this.setState({header:response.logo2})
          });
    }

    handleChange(e){
        if (e.target.name =='periodo') {
            console.log(e.target.value);
			var spliltperiodo = e.target.value.split('-');
            
			this.setState({
				year:spliltperiodo[0],month:spliltperiodo[1],periodo:e.target.value
			});
		}
        this.setState({
			[e.target.name]: e.target.value
		});
        
    };
    searching(e){
        e.preventDefault();
        if (this.state.periodo!="") {
            fetch(Config.default.apiGateway.URL+'incidents_extraction?periodo='+this.state.periodo+'-01'+'&hf_id='+sessionStorage.getItem('health_facilities_id'),{
                method:'GET',
                headers:new Headers({
                    'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8'
                  })
            }).then(res => {
                if(res.ok){
                  return res.json();
                }console.log(res)})
              .catch(error => console.error('Error:', error))
              .then(response => {
                  //console.log(response);
                  this.setState({data:response.agrupado})
              });
        }else{
            swal('Error', 'Selecciona un periodo','error');
        }
        
    };
    
    getDates(data) {
        console.log(data)
        const allDates = data.map(item => new Date(item.date));
    const minDate = new Date(Math.min(...allDates));
    const maxDate = new Date(Math.max(...allDates));

    // Definir el rango de fechas (del 26 de un mes al 25 del siguiente)
	const startDate = new Date(parseInt(this.state.year),(parseInt(this.state.month)-1),26);
	const endDate = new Date(parseInt(this.state.year),parseInt(this.state.month),25);

    const dates = [];
    let currentDate = new Date(startDate);
    while (currentDate <= endDate) {
      dates.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dates.map(date => date.toISOString().split('T')[0]);
      }
    
      getUniqueIncidents(data) {
        const allIncidents = data.flatMap(item =>
          item.incidentscount.flatMap(incidentCount =>
            incidentCount.incident
          )
        );
        return [...new Set(allIncidents)];
      }
      exportToExcel = () => {
        const table = document.querySelector('table');
        const ws = XLSX.utils.table_to_sheet(table);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, 'tabla.xlsx');
      };
      exportToPDF = () => {
        const input = document.querySelector('.table-responsive');
        html2canvas(input).then(canvas => {
          const imgData = canvas.toDataURL('image/png');
          const pdf = new jsPDF('l', 'mm', 'a4');
          const imgWidth = 250; // Ancho en mm para formato A4
          const pageHeight = 295; // Altura en mm para formato A4
          const imgHeight = canvas.height * imgWidth / canvas.width;
          let heightLeft = imgHeight;
    
          let position = 20;
    
        // Agregar encabezado (header) con imagen
        //const headerImgData = 'data:image/png;base64,'+this.state.header; // Reemplaza con tu imagen en base64
        const headerImgData = this.props.header_document;
        pdf.addImage(headerImgData, 'PNG', 90, 10, 100,20); // Ajusta las coordenadas y el tamaño según necesites
        const headerText = "HOJA DIARIA\nREPORTE DE REACCIONES ADVERSAS A LA DONACIÓN DE SANGRE";
      const headerTextX = 140; // Coordenada X para el texto (ajusta según necesites)
      const headerTextY = 35; // Coordenada Y para el texto (ajusta según necesites)
      const lineHeight = 4; // Altura de línea para el texto (ajusta según necesites)
        pdf.setFontSize(8);
        // Dividir el texto en líneas
      const lines = headerText.split('\n');
       lines.forEach((line, index) => {
         pdf.text(line, headerTextX, headerTextY + (index * lineHeight), { align: 'center' });
       });
          pdf.addImage(imgData, 'PNG', 20, 50, imgWidth, imgHeight);
          heightLeft -= pageHeight;
    
          while (heightLeft >= 0) {
            position = heightLeft - imgHeight;
            pdf.addPage();
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
        // Añadir números de página
        const totalPages = pdf.internal.getNumberOfPages();
        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(10);
          const pageHeight = pdf.internal.pageSize.height; // Altura de la página actual
          pdf.text(`Página ${i} de ${totalPages}`, pdf.internal.pageSize.width - 20, pageHeight - 10, { align: 'right' });
        }
          pdf.save('Incidents.pdf');
        });
      };
      splitdate(date){
        var sd = date.split("T");
        return sd[0];
    }
    renderDate(date){
        var sd = date.split("-");
        return sd[2];
    }
    getMonthName(monthNumber) {
        const monthNames = [
          'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
          'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
        ];
        return monthNames[monthNumber - 1];
    }
    render(){
		const {t} = this.props;
        //const daysInMonth = this.getDaysInRange(this.state.year!=""?parseInt(this.state.year):2024,this.state.month!=""?parseInt(this.state.month):1)

        const { data } = this.state;
        const dates = this.getDates(data);
        console.log(dates)
    const incidents = this.getUniqueIncidents(data);
    console.log(incidents);
        return (
<div className="col-xs-12">
				<div className="route mt-1" >
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
                    ESTADISTICA DE INCIDENTES EXTRACCION
					</h5>
				</div>
                <div className="form-group" style={{paddingLeft:"0.5em"}}>
                <div className="col-xs-12">
                    <form>
                    <div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>								
                                <div className="col-xs-12 form-group">
                                    <span className="span-min">Periodo</span>
                                    <input type="month" className="form-control hour-input" name="periodo" id="periodo"
                                         onChange={this.handleChange} required />
                                </div>
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>
                            
                            <div className="col-xs-12 col-sm-10">
								<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline",fontSize:'16px'}}>
									<span>
										{this.state.filename}
									</span>
								</div>
								<div className="col-xs-12" >
									
								</div>

								<div className='col-xs-12' style={{textAlign:"right"}}>
                                <Button className="btn btn-info mr-3" onClick={this.exportToExcel} 
									style={{fontSize:"1em"}}>
										Excel
									</Button>
									<Button className="btn btn-info ml-3" onClick={(e)=>this.exportToPDF()} style={{ float: "right" ,fontSize:"1em"}}>
									PDF
									</Button>
								</div>
                                <div style={{textAlign:"center"}}>
                                <label >ESTADISTICA DE INCIDENTES DE EXTRACCIÓN</label>
                                </div>
                                
                                <div className="col-xs-12 form-group mt-2" id="table-to-pdf">
                                    
                            <div className="table-responsive">
                                <div>
                                <label className='mr-5'>MES:{this.getMonthName(this.state.month)}</label>
                                <label className='mr-5'>AÑO:{this.state.year}</label>
                                <label className='mr-5'>RESPONSABLE(S):_____________________</label>
                                </div>
                            <Table className="table mt-3" style={{fontSize:"11px"}}>
                            <thead>
            <tr>
              <th>ELEMENTOS ADVERSOS A LA DONACIÓN</th>
              {dates.map(date => (
                <th key={date}>{this.renderDate(date)}</th>
              ))}
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {incidents.map(incident => (
              <tr key={incident}>
                <td>{incident}</td>
                {dates.map(date => {
                  const dateData = data.find(item =>this.splitdate(item.date)  === date);
                  console.log(dateData);
                  const count = dateData ? dateData.incidentscount.reduce((acc, current) => {
                    
                    if (current.incident.includes(incident)) {
                      return acc + current.count;
                    }
                    return acc;
                  }, 0) : 0;
                  return <td key={date}>{count}</td>;
                })}
                <td>
                  {dates.reduce((acc, date) => {
                    const dateData = data.find(item => this.splitdate(item.date) === date);
                    const count = dateData ? dateData.incidentscount.reduce((acc, current) => {
                      if (current.incident.includes(incident)) {
                        return acc + current.count;
                      }
                      return acc;
                    }, 0) : 0;
                    return acc + count;
                  }, 0)}
                </td>
              </tr>
            ))}
          </tbody>
                    </Table>
                            </div>
                            </div>
                            </div>
                            
                    </form>
                    
                </div>
                </div>
</div>
        )
    }
}
export default translate('translations')(IncidentReport)